import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';

import { getUserAssignment } from '../../../../../../services/apiService';
import ViewFeedbackModal from '../../../../../../components/almaX/utils/ViewFeedbackModal';

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};

const pageSize = 10;

function Assignment({ goalType, userId }) {
  const columnDefs = [
    { field: 'id', hide: true },

    { field: 'name', headerName: 'Name' },
    { field: 'moduleName', headerName: 'Module' },
    { field: 'attemptNumber', headerName: 'Attempt' },
    {
      field: 'credits',
      headerName: 'Score',
      cellRenderer: function (params) {
        console.log(params);
        return (
          <div>
            {params?.data?.credits && (
              <ViewFeedbackModal
                displayText={params?.data?.credits}
                goalType={goalType}
                assignmentId={params?.data?.id}
                userId={userId}
                assignmentImgUrl={null}
                assignmentName={params.data?.name}
              />
            )}
          </div>
        );
      },
    },
    { field: 'adminStatus', headerName: 'Admin Status' },
    { field: 'evaluationStatus', headerName: 'Evaluation Status' },
  ];

  const [rowData, setRowData] = useState(null);

  const fetchData = async () => {
    try {
      if (goalType && userId) {
        const response = await getUserAssignment(goalType, userId);
        setRowData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [goalType, userId]);

  return (
    <div>
      <div className='ag-theme-alpine h-96  w-full'>
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
}

export default Assignment;
